/* eslint-disable */
import { AfterViewInit, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { description_min_rows } from '@pt/pt-models';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmObsoleteDialogResponse } from '../models';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'pt-confirm-obsolete-dialog',
  template: `
    <div class='modal-header'
         (click)='$event.stopPropagation()'>
      <h4 class='modal-title'>
        {{ title | async }}
      </h4>
    </div>

    <div class='modal-body' (click)='$event.stopPropagation()'>
      <p [innerHTML]='message | async'></p>

      <form [formGroup]="formNote">
        <pt-input-text-area
          [minRow]='descriptionMinRows'
          [inputId]='"note"'
          formControlName='note'
          [label]="'LABELS.NOTE' | translate"
        ></pt-input-text-area>
      </form>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              (click)='confirmed()'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </button>

      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>

  `,
  styles: [``]
})
export class ConfirmObsoleteDialogComponent implements AfterViewInit {
  @Input() title: Observable<string>;
  @Input() message: Observable<string>;

  public TEXT_FOR_DELETE = null;

  public formNote: FormGroup = new FormGroup({
    note: new FormControl(null)
  })

  constructor(public activeModal: NgbActiveModal, private translateService: TranslateService) {
  }

  ngAfterViewInit() {
    const timeout = setTimeout(() => {
        this.translateService.stream('MESSAGE.DELETE_TO_CONFIRM_VALUE').subscribe({
          next: (message) => {
            this.TEXT_FOR_DELETE = message;
          }, error: () => {
            this.TEXT_FOR_DELETE = 'DELETE'
          }
        });
      clearTimeout(timeout);
    }, 300)
  }

  confirmed() {
    const response: ConfirmObsoleteDialogResponse = {
      note: this.formNote.controls.note.value
    }
    this.activeModal.close(response);
  }

  protected readonly descriptionMinRows = description_min_rows;
}

